import * as React from "react"

import { cn } from "@/lib/utils"

function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "flex field-sizing-content min-h-16 w-full rounded-md border border-white/12 bg-white/[0.05] px-3 py-2 text-base text-white shadow-none transition-[color,box-shadow,background-color] outline-none placeholder:text-white/35 focus-visible:border-white/22 focus-visible:bg-white/[0.07] focus-visible:ring-[3px] focus-visible:ring-white/12 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      {...props}
    />
  )
}

export { Textarea }
